import { axiosClientPortalInstance } from "./";

const clientReportsPath = (eventId) => `/events/${eventId}/client_reports`;

/**
 * GET /client_portal/v1/events/:eventId/client_reports
 * Pagination metadata comes back in the `Current-Page` / `Total-Count` /
 * `Total-Pages` headers. `page: -1` returns every report unpaginated.
 */
const getClientPortalClientReports = (eventId, params = {}) =>
  axiosClientPortalInstance.get(clientReportsPath(eventId), { params });

/** POST /client_portal/v1/events/:eventId/client_reports */
const createClientPortalClientReport = (eventId, data) =>
  axiosClientPortalInstance.post(clientReportsPath(eventId), data);

/**
 * GET /client_portal/v1/events/:eventId/client_reports/:id — returns a fresh `upload_url`.
 * Silent: the download / preview flows show their own progress, not the global loader.
 */
const getClientPortalClientReport = (eventId, id) =>
  axiosClientPortalInstance.get(`${clientReportsPath(eventId)}/${id}`, {
    handlerEnabled: false,
  });

/**
 * DELETE /client_portal/v1/events/:eventId/client_reports/:id
 * Allowed only when the report came back with `is_deletable: true`.
 * Silent: the Delete flow shows its own error message, not the global toast.
 */
const deleteClientPortalClientReport = (eventId, id) =>
  axiosClientPortalInstance.delete(`${clientReportsPath(eventId)}/${id}`, {
    handlerEnabled: false,
  });

export {
  getClientPortalClientReports,
  createClientPortalClientReport,
  getClientPortalClientReport,
  deleteClientPortalClientReport,
};
